import React, { useEffect, useContext, useState } from "react";
import { motion } from "framer-motion";
import {
  CssBaseline,
  ThemeProvider,
  createTheme,
  IconButton,
  Box,
  Typography,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
} from "@mui/material";
import { Brightness4, Brightness7, Menu as MenuIcon, Logout } from "@mui/icons-material";
import { ThemeContext } from "../ThemeContext";
import { Link } from "react-router-dom";

function Home_menu() {
  const { darkMode, toggleTheme } = useContext(ThemeContext);
  const [menuOpen, setMenuOpen] = useState(false);
  const [animationComplete, setAnimationComplete] = useState(false);
  const isMobile = useMediaQuery("(max-width: 768px)");

  const theme = createTheme({
    palette: {
      mode: darkMode ? "dark" : "light",
      background: {
        default: darkMode ? "#0d1117" : "#f9f9f9",
      },
      text: {
        primary: darkMode ? "#c9d1d9" : "#000000",
        secondary: darkMode ? "#8b949e" : "#5f6368",
      },
    },
  });

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      window.location.href = "/";
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    window.location.href = "/";
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box
        sx={{
          position: "absolute",
          top: 16,
          right: 16,
        }}
      >
        <IconButton onClick={toggleTheme} color="inherit">
          {darkMode ? <Brightness7 /> : <Brightness4 />}
        </IconButton>
      </Box>

      {isMobile && (
        <Box
          sx={{
            position: "absolute",
            top: 16,
            left: 16,
          }}
        >
          <IconButton onClick={toggleMenu} color="inherit">
            <MenuIcon />
          </IconButton>
        </Box>
      )}

      <motion.div
        initial={{ width: "100vw" }}
        animate={{ width: "70vw" }}
        transition={{ duration: 1.5 }}
        onAnimationComplete={() => setAnimationComplete(true)}
        style={{
          height: "100vh",
          background: darkMode
            ? "radial-gradient(circle, #0d1117 0%, #161b22 100%)"
            : "radial-gradient(circle, #f9f9f9 0%, #ffffff 100%)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "8px",
          margin: "auto",
          boxShadow: darkMode
            ? "0 4px 20px rgba(0, 0, 0, 0.8)"
            : "0 4px 20px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: "800px",
            p: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Typography
            variant="h5"
            align="center"
            gutterBottom
            sx={{
              fontWeight: "bold",
              color: theme.palette.text.primary,
            }}
          >
            Видео-инструкция
          </Typography>
          <Box
            sx={{
              position: "relative",
              width: "100%",
              paddingTop: "56.25%", // 16:9 aspect ratio
              borderRadius: "8px",
              overflow: "hidden",
            }}
          >
            <iframe
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                border: "none",
              }}
              src="https://www.youtube.com/embed/OyVLTWamWn4"
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </Box>
        </Box>
      </motion.div>

      {/* Остальная часть кода с Drawer остается без изменений */}
      {!isMobile && animationComplete && (
        <Drawer
          variant="permanent"
          anchor="left"
          sx={{
            "& .MuiDrawer-paper": {
              width: "240px",
              backgroundColor: darkMode ? "#0d1117" : "#f9f9f9",
              color: theme.palette.text.primary,
            },
          }}
        >
          <List>
            <ListItem button component={Link} to="/Home_menu">
              <ListItemText primary="Домой" />
            </ListItem>
            <ListItem button component={Link} to="/add-profile">
              <ListItemText primary="Добавить профайл" />
            </ListItem>
            <ListItem button component={Link} to="/Bot">
              <ListItemText primary="Бот" />
            </ListItem>
            <ListItem button onClick={handleLogout}>
              <Logout />
              <ListItemText primary="Выход" />
            </ListItem>
          </List>
        </Drawer>
      )}

      {isMobile && animationComplete && (
        <Drawer
          anchor="left"
          open={menuOpen}
          onClose={toggleMenu}
          sx={{
            "& .MuiDrawer-paper": {
              width: "240px",
              backgroundColor: darkMode ? "#0d1117" : "#f9f9f9",
              color: theme.palette.text.primary,
            },
          }}
        >
          <List>
            <ListItem button component={Link} to="/Home_menu">
              <ListItemText primary="Домой" />
            </ListItem>
            <ListItem button component={Link} to="/add-profile">
              <ListItemText primary="Добавить профайл" />
            </ListItem>
            <ListItem button component={Link} to="/Bot">
              <ListItemText primary="Бот" />
            </ListItem>
            <ListItem button onClick={handleLogout}>
              <Logout />
              <ListItemText primary="Выход" />
            </ListItem>
          </List>
        </Drawer>
      )}
    </ThemeProvider>
  );
}

export default Home_menu;